import script from "./DialogPatrolDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogPatrolDetails.vue?vue&type=script&setup=true&lang=ts"

import "./DialogPatrolDetails.vue?vue&type=style&index=0&id=04ca3238&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ca3238"]])

export default __exports__